export const initZohoSalesIQ = (user, visitorInfo) => {
    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || {
        widgetcode: import.meta.env.VITE_ZOHO_SALESIQ_KEY,
        values: {
            name: `${user.firstName} ${user.lastName}`,
            email: `${user.email}`,
            language: `${user.lang}`,
        },
        ready: () => {
            window.$zoho.salesiq.visitor.info(visitorInfo);
            window.$zoho.salesiq.floatbutton.visible('hide');
        },
    };
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'zsiqscript';
    script.defer = true;
    script.src = import.meta.env.VITE_ZOHO_SALESIQ_LINK;
    document.body.appendChild(script);
};
